import store from '@/store'

export default {
    update(el, binding, vnode) {
        try {
            if (store.state.process.perms.length > 0) {
                const item = store.state.process.perms.find(item => item.id === binding.value)
                if (!item || !item.perm || item.perm === 'H') {
                    // 隐藏元素
                    el.style.display = 'none'
                }else{
                    // 显示元素
                    el.style.display = ''
                }
            }
        } catch (e) {

            console.error('------------ 自定义指令异常 ------------', e, binding)
        }

    }
}
